<template>
  <div class="kaart">
      <img src="../assets/kaart_zuilen_hd.jpg">
      <img class="logo" src="../assets/logo.png" alt="logo">
      <div class="button-home"><router-link to="/"><img src="../assets/buttons/button_home.svg" alt="button home"></router-link></div>
      <div class="button-map"><img src="../assets/buttons/button_map.svg" alt="button map"></div>
      <div class="button-map-reunies"><router-link to="/reuniekaart"><img src="../assets/buttons/button_map_reunies.svg" alt="button map"></router-link></div>
      <div v-bind:key="pin.id" v-for="pin in pins" style="position: absolute;" v-bind:style="{ top: pin.y + 'px', left: pin.x + 'px' }">
        <img class="pin" src="../assets/pins/Zuilen_pin_blanco_v2.svg" alt="pin"  @click="showInfo(pin.id)">
        <div class="pintext" @click="showInfo(pin.id)">{{ pin.pin }}</div>
      </div>
  </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';
export default {
  name: 'Kaart',
  props: [],
  data() {
    return {
      pins: []
    };
  },
  methods: {
      showInfo: (idIn) => {
          // console.log(idIn);
          router.push('/item/' + idIn);
      }
  },
  created() {
    axios.get(config.api + 'items?collection=1&key=' + config.api_key)
    .then((res) => {
      res.data.forEach(record => {
        var pinItem = {};
        // console.log('record: ' + record.id);
        pinItem.id = record.id;
        record.element_texts.forEach(text_element => {
          if(text_element.element.name === 'Titel') {
            // console.log('titel: '+ text_element.text);
            pinItem.title = text_element.text;
          }
          if(text_element.element.name === 'Pin') {
            // console.log('pin: '+ text_element.text);
            pinItem.pin = text_element.text;
          }
          if(text_element.element.name === 'Omschrijving') {
            // console.log('omschrijving: '+ text_element.text);
            // console.log('omschrijving html: '+ text_element.html);
            pinItem.omschrijving = text_element.text;
            pinItem.omschrijving_html = text_element.html;
          }
          if(text_element.element.name === 'Xpos') {
            // console.log('xpos: '+ text_element.text);
            pinItem.x = parseInt(text_element.text) - 15;
          }
          if(text_element.element.name === 'Ypos') {
            // console.log('ypos: '+ text_element.text);
            pinItem.y = parseInt(text_element.text);
          }
        });
        this.pins.push(pinItem);
      });
    })
    .catch(err => console.log(err));
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.kaart {
    /* background-image: '../assets/kaart_zuilen_hd.jpg'; */
    width: 1920px;
    height: 1080px;
    overflow: hidden;
    text-align: center;
}
.logo {
    position: absolute;
    top: 80px;
    left: 1645px;
    width: 120px;
    height: auto;
}
.pin {
    position: absolute;
    width: 30px;
    height: auto;
}
.pintext {
  font-weight: 700;
  font-size: 0.6em;
  width: 30px;
  position: relative; 
  /* z-index: 999;  */
  left: 15px; 
  top: 9px;
  color: #c1292f;
}
.button-home {
    position: absolute;
    top: 117px;
    left: 65px;
    width: 38px;
    height: auto;
}
.button-map {
    position: absolute;
    top: 200px;
    left: 50px;
    width: 50px;
    height: auto;
    opacity: 50%;
}
.button-map-reunies {
    position: absolute;
    top: 280px;
    left: 50px;
    width: 50px;
    height: auto;
}
</style>
